export default __webpack_public_path__ + "static/media/misc-books3-480w.5ac01bbb.avif";